import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import User from "models/user";
import Screen from "models/screen";
import { Department, JobTitle } from "models/org-chart-node";
import Employee from "models/employee";

export interface LoginSliceState {
    error: string,
    loading: boolean,
    isUserLogout: boolean,
    errorMsg: boolean,
}

export const initialState: LoginSliceState = {
    error: "",// for error msg
    loading: false,
    isUserLogout: false,
    errorMsg: false,// for error, 
};

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        loginSuccess(state) {
            state.loading = false;
            state.errorMsg = false;
        },
        apiError(state, { payload }: PayloadAction<string>) {
            state.error = payload;
            state.loading = true;
            state.isUserLogout = false;
            state.errorMsg = true;
        },
        resetLoginFlag(state) {
            // state.error = null;
            state.error = "";
            state.loading = false;
            state.errorMsg = false;
        },
        logoutUserSuccess(state, action) {
            state.isUserLogout = true
        },
    }
});
export const {
    loginSuccess,
    apiError,
    resetLoginFlag,
    logoutUserSuccess,
} = loginSlice.actions;
export default loginSlice.reducer;